/*

 */
/** 直接从数组 或者对象里面取值 */
var getSiteValue = function getSiteValue(param, key) {
  var getKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'key';
  if (Array.isArray(param)) {
    return param.find(function (i) {
      return i[getKey] === key;
    });
  } else {
    return param[key];
  }
};

/**
 *
 * @param params store数据
 * @param key 要查找的key
 * @param  options 配置
 * @returns 返回找到的站点数据
 */
var findSiteData = function findSiteData(params, key) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$getKey = _ref.getKey,
    getKey = _ref$getKey === void 0 ? 'key' : _ref$getKey,
    _ref$isAvaricious = _ref.isAvaricious,
    isAvaricious = _ref$isAvaricious === void 0 ? true : _ref$isAvaricious,
    onError = _ref.onError,
    _ref$findKey = _ref.findKey,
    findKey = _ref$findKey === void 0 ? 'configList' : _ref$findKey;
  var findResult;
  try {
    if (!params) return;
    if (Array.isArray(params)) return getSiteValue(params, key, getKey);
    if (key === 'sid') {
      var _params$data;
      return params === null || params === void 0 || (_params$data = params.data) === null || _params$data === void 0 ? void 0 : _params$data.sid;
    }
    var dfs = function dfs(value) {
      if (Object.prototype.toString.call(value) !== '[object Object]') return;
      var valueKeys = Reflect.ownKeys(value);
      if (valueKeys.includes(findKey)) {
        findResult = getSiteValue(value[findKey], key, getKey);
        throw Error();
      } else {
        valueKeys.forEach(function (k) {
          dfs(value[k]);
        });
      }
    };
    dfs(params);
  } catch (err) {
    onError === null || onError === void 0 || onError(err);
  }
  return findResult;
};

/**
 * @name 将站点数据中的configList字段的value转换为boolean
 *
 * @param params store数据
 * @param key 要查找的key
 * @param options 配置
 * @returns 返回找到的站点configList数据的value的boolean
 * value 为假值、'0'、'false'时 返回false 否则返回true
 */

var findConfigValueToBoolean = function findConfigValueToBoolean(params, key) {
  var _findSiteData;
  var value = ((_findSiteData = findSiteData(params, key)) === null || _findSiteData === void 0 ? void 0 : _findSiteData.value) || '';
  if (!value || value === '0' || value === 'false') {
    return false;
  } else {
    return true;
  }
};
export { getSiteValue, findSiteData, findConfigValueToBoolean };